import { parseAsString, useQueryState, UseQueryStateOptions } from 'nuqs';

import { useResourceRoutePreview } from '@/shared/components/resource-route-preview/context';

export const resourcePreviewQueryPrefix = (activityId: string) => `inbox-preview:${activityId}:`;

/** Preserve nuqs' parser/default overloads, while isolating its global sync keys inside a portal. */
export const useResourceQueryState = ((key: string, options?: UseQueryStateOptions<unknown>) => {
    const preview = useResourceRoutePreview();
    return useQueryState(
        preview ? resourcePreviewQueryPrefix(preview.activityId) + key : key,
        options ?? parseAsString,
    );
}) as typeof useQueryState;
